/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProposalOverviewProductViewModel } from './ProposalOverviewProductViewModel';
import {
    ProposalOverviewProductViewModelFromJSON,
    ProposalOverviewProductViewModelFromJSONTyped,
    ProposalOverviewProductViewModelToJSON,
} from './ProposalOverviewProductViewModel';

/**
 * 
 * @export
 * @interface ProposalOverviewScenarioViewModel
 */
export interface ProposalOverviewScenarioViewModel {
    /**
     * 
     * @type {number}
     * @memberof ProposalOverviewScenarioViewModel
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalOverviewScenarioViewModel
     */
    proposalId: number;
    /**
     * 
     * @type {string}
     * @memberof ProposalOverviewScenarioViewModel
     */
    description?: string;
    /**
     * 
     * @type {Array<ProposalOverviewProductViewModel>}
     * @memberof ProposalOverviewScenarioViewModel
     */
    products?: Array<ProposalOverviewProductViewModel>;
    /**
     * 
     * @type {Date}
     * @memberof ProposalOverviewScenarioViewModel
     */
    dateCreated: Date;
}

/**
 * Check if a given object implements the ProposalOverviewScenarioViewModel interface.
 */
export function instanceOfProposalOverviewScenarioViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "proposalId" in value;
    isInstance = isInstance && "dateCreated" in value;

    return isInstance;
}

export function ProposalOverviewScenarioViewModelFromJSON(json: any): ProposalOverviewScenarioViewModel {
    return ProposalOverviewScenarioViewModelFromJSONTyped(json, false);
}

export function ProposalOverviewScenarioViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalOverviewScenarioViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['Id'],
        'proposalId': json['ProposalId'],
        'description': !exists(json, 'Description') ? undefined : json['Description'],
        'products': !exists(json, 'Products') ? undefined : ((json['Products'] as Array<any>).map(ProposalOverviewProductViewModelFromJSON)),
        'dateCreated': (new Date(json['DateCreated'])),
    };
}

export function ProposalOverviewScenarioViewModelToJSON(value?: ProposalOverviewScenarioViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'ProposalId': value.proposalId,
        'Description': value.description,
        'Products': value.products === undefined ? undefined : ((value.products as Array<any>).map(ProposalOverviewProductViewModelToJSON)),
        'DateCreated': (value.dateCreated.toISOString()),
    };
}

